import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import disableScroll from 'disable-scroll';
export default {
    is_openend: false,
    opened_menu: undefined,
    init() {
        //getting the header.
        let header = document.getElementById('header');
        const STICK_HEIGHT = 600;
        let current_height_target = STICK_HEIGHT;
        var timer = null;
        if(header) {
            let header_height = header.offsetHeight + "px";
            let header_placeholder = document.querySelector('#header-placeholder');
            if(header_placeholder) {
                header_placeholder.style.height = header_height;
            }
            $(window).scroll(() => {
                var scroll_top = $(window).scrollTop();
                if(scroll_top >= STICK_HEIGHT) {
                    var top  = window.pageYOffset || document.documentElement.scrollTop;
                    console.log('timer: ' + timer);
                    clearTimeout(timer);
                    timer = null;
                    header.classList.add('sticky');
                    header.classList.add('visible');
                    if(this.inside_map(scroll_top)) {
                        // header.style.display = "none";
                        header.classList.remove('visible');
                        header.classList.add('hidden');
                    }
                     else {
                        if(header.classList.contains('hidden')) {
                            header.classList.remove('hidden');
                        }
                        // header.style.display = "block"
                        if(!header.classList.contains('visible')) {
                            header.classList.add('visible');
                        }
                    }
                } else {
                    header.classList.remove('visible');
                    header.classList.add('hidden');
                    if(timer === null)
                    timer = setTimeout(() => {
                        var top  = window.pageYOffset || document.documentElement.scrollTop;
                        // let next_el = document.querySelector('#header + *').style.marginTop = 0 + "px";
                        header.classList.remove('sticky');
                        header.classList.remove('hidden');
                        header.classList.remove('visible')
                        timer = null;
                    }, 250);
                }
            });
        }
        if(window.innerWidth > 1200) {
            let link_with_menus = document.querySelectorAll('.menu-item');
            link_with_menus.forEach(link => {
                link.addEventListener('mouseover', (e) => {
                    if(link !== this.opened_menu) {
                        this.is_openend = true;
                        this.opened_menu = link
                        link.classList.add('visible');

                        link_with_menus.forEach(closing_link => {
                            if(closing_link !== this.opened_menu) {
                                closing_link.classList.remove('visible')
                            }
                        });
                    }
                })
            })
            $(document).mousemove((e) => {
                let selected_link = document.querySelector('.menu-item.visible:not(.menu-item-has-children)');
                if(selected_link) {
                    var body_rect = document.body.getBoundingClientRect();
                    var selected_link_rect = selected_link.getBoundingClientRect();
                    var offset = selected_link_rect.bottom - body_rect.top;

                    if(e.pageY > offset) {
                        selected_link.classList.remove('visible');
                    }
                }

                if(this.opened_menu) {
                    let sub_menu = this.opened_menu.querySelector('.sub-menu');
                    if(sub_menu){
                        var bodyRect = document.body.getBoundingClientRect(),
                        elemRect = sub_menu.getBoundingClientRect(),
                        offset   = elemRect.bottom - bodyRect.top;

                        //if user has moved past living menu.
                        if(e.pageY > offset) {
                            this.opened_menu.classList.remove('visible');
                            this.opened_menu = undefined;
                        }
                    }
                }
            });
            if(window.innerWidth >= 1200) {
                document.querySelectorAll('.menu-item-has-children > a').forEach(link => {
                    link.addEventListener('keydown', (e) => {
                        if (e.keyCode === 13) {
                            e.preventDefault();
                            link.parentElement.classList.add('visible');
                        }
                    })
                })
            }

            document.querySelectorAll('.sub-link a').forEach(link => {
                link.addEventListener('click', e => {
                    document.activeElement.blur();
                })
            })

            if(window.innerWidth >= 1200) {
                document.addEventListener('focusin', () => {
                    console.log('focused: ', document.activeElement)
                    let curr_focus = document.activeElement;
                    if(!curr_focus.parentElement.classList.contains('menu-item-has-children') && !curr_focus.parentElement.classList.contains('sub-link')) {
                        let opened_menu = document.querySelector('.menu-item-has-children.visible');
                        if(opened_menu) {
                            opened_menu.classList.remove('visible')
                        }
                    }
                }, true);
            }
        } else {
            if(window.innerWidth >= 1200) {
                document.querySelectorAll('.menu-item-has-children a').forEach(sub_menu_button => {
                    sub_menu_button.addEventListener('click', (e) => {
                        if(e.target.parentElement.classList.contains('menu-item-object-page')) {
                            e.preventDefault();
                        }
                        sub_menu_button.parentElement.classList.toggle('visible');
                    })
                })
            }
        }

        /* For mobile, when the user clicks the show menu button display the nav_menu below. */
        let menu_button = document.getElementById('show-menu');
        if(menu_button) {
            let menu_toggle = () => {
                document.activeElement.blur();
                let banner = document.querySelector('#header .banner')
                if(!menu_button.classList.contains('active')) {
                    disableScroll.on();
                    if(window.innerWidth < 1200 && banner) {
                        banner.style.display = "none";
                    }
                } else {
                    disableScroll.off();
                    if(window.innerWidth < 1200 && banner) {
                        banner.style.display = "block";
                    }
                }

                menu_button.classList.toggle('active')
                document.querySelector('.menu-modal').classList.toggle('active');
            }

            let is_ios = this.iOS();

            if(!is_ios) {
                menu_button.addEventListener('click', () => {
                    menu_toggle();
                })
            }

            if(is_ios) {
                menu_button.addEventListener('touchstart', () => {
                    menu_toggle();
                })
            }

            let modal = document.querySelector('.menu-modal');
            if(modal) {
                modal.addEventListener('click', (e) => {
                    if(e.target === modal) {
                        menu_toggle();
                    }
                })
            }
        }
    },

    /**
     * Function to determine whether the user is currently viewing the map or not.
     * @returns {Boolean} Whether or not we are inside the maps co-ordinates
     */
    inside_map(scroll_top) {
        let map = document.getElementById('tab-map');
        //getting the scroll location of the map.
        if(map) {
            const MAP_OFFSET = 150;
            const MAP_SCROLL = window.pageYOffset + map.getBoundingClientRect().top + -MAP_OFFSET
            const MAP_HEIGHT = map.offsetHeight;

            if(scroll_top >= MAP_SCROLL && scroll_top <= MAP_SCROLL + MAP_HEIGHT + MAP_OFFSET) {
                // window.scrollBy(0, 2);
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },
     iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
}